import axios from 'axios';
import { DecryptFromBase64WithPassword } from '../cript/cript';
import { BASE_URL, GET_CHECKOUT_BY_ID } from '../endpoints/endpoints';

export async function GetAllData(id) {
  const resultError = {
    enabled: false,
  };

  try {
    if (!id) {
      return resultError;
    }

    const response = await axios.get(BASE_URL + GET_CHECKOUT_BY_ID + '?id=' + id);
    
    if(response.status !== 200) {
      return resultError;
    }
    
    const data = await response.data;

    if (!data) {
      return resultError;
    }

    const decode64 = DecryptFromBase64WithPassword(data);

    return decode64.data;
  } catch (e) {
    return resultError;
  }
}

